/** Enhance native details. All selectors are scoped to one data-accordion root. */
export function initAccordion(root) {
  const items = [...root.querySelectorAll('[data-accordion-item]')].filter(el => el.closest('[data-accordion]') === root && el.querySelector('[data-accordion-trigger]') && el.querySelector('[data-accordion-panel]'));
  const motion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const state = new Map();
  const cleanups = [];
  let interacted = false;
  function setOpen(item, open, animate = true) {
    const s = state.get(item);
    if (!s) return;
    const from = item.open ? s.panel.getBoundingClientRect().height : 0;
    s.animation?.cancel();
    s.animation = null;
    s.open = open;
    s.panel.inert = !open;
    s.trigger.setAttribute('aria-expanded', String(open));
    item.dataset.open = String(open);
    item.open = true;
    const to = open ? s.panel.scrollHeight : 0;
    if (!animate || motion.matches || from === to) {
      item.open = open;
      return;
    }
    const animation = s.panel.animate([{height:`${from}px`,opacity:from ? 1 : 0},{height:`${to}px`,opacity:open ? 1 : 0}],{duration:280,easing:'cubic-bezier(.2,.65,.3,1)'});
    s.animation = animation;
    animation.onfinish = () => { if (s.animation === animation) { item.open = open; s.animation = null; } };
  }
  function openItem(item) {
    interacted = true;
    const next = !state.get(item).open;
    if (next && root.dataset.accordionMultiple !== 'true') items.forEach(other => {if(other !== item && state.get(other).open) setOpen(other,false);});
    setOpen(item,next);
  }
  let foundOpen = false;
  items.forEach(item => {
    const trigger = item.querySelector('[data-accordion-trigger]');
    const panel = item.querySelector('[data-accordion-panel]');
    if (!trigger || !panel) return;
    const open = item.open && (!foundOpen || root.dataset.accordionMultiple === 'true');
    foundOpen ||= open;
    state.set(item,{trigger,panel,open,animation:null});
    setOpen(item,open,false);
    const click = event => { event.preventDefault(); openItem(item); };
    const key = event => {
      const keys = ['ArrowDown','ArrowUp','Home','End'];
      if (!keys.includes(event.key)) return;
      event.preventDefault();
      const triggers=items.map(i=>state.get(i)?.trigger).filter(Boolean);const index=triggers.indexOf(trigger);
      const next=event.key==='Home'?0:event.key==='End'?triggers.length-1:(index+(event.key==='ArrowDown'?1:-1)+triggers.length)%triggers.length;
      triggers[next].focus();
    };
    trigger.addEventListener('click',click);trigger.addEventListener('keydown',key);
    cleanups.push(()=>{trigger.removeEventListener('click',click);trigger.removeEventListener('keydown',key);state.get(item).animation?.cancel();item.open=state.get(item).open;});
  });
  const reduce = () => {if(motion.matches) items.forEach(i=>setOpen(i,state.get(i).open,false));};
  motion.addEventListener('change',reduce);
  const revealHash = () => {
    let id;try {id=decodeURIComponent(location.hash.slice(1));} catch {return;}
    const target=document.getElementById(id);
    const item=target?.closest('[data-accordion-item]');
    if(!items.includes(item)) return;
    interacted = true;
    if(root.dataset.accordionMultiple!=='true') items.forEach(other=>{if(other!==item) setOpen(other,false,false);});
    setOpen(item,true,false);item.scrollIntoView({block:'start',behavior:'instant'});
  };
  window.addEventListener('hashchange',revealHash);
  revealHash();
  let revealObserver,revealTimer;
  if(root.dataset.accordionReveal!==undefined && !location.hash) {
    root.dataset.accordionRevealState='pending';
    const reveal = () => {
      root.dataset.accordionRevealState='visible';
      root.classList.add('is-visible');
      revealTimer = setTimeout(() => {
        if(!interacted && items[0]) setOpen(items[0],true,!motion.matches);
      }, motion.matches ? 0 : 560);
    };
    if(motion.matches) reveal();
    else {
      revealObserver = new IntersectionObserver(entries => {
        if(!entries.some(entry => entry.isIntersecting)) return;
        revealObserver.disconnect();
        reveal();
      }, {rootMargin:'0px 0px -12% 0px',threshold:.18});
      revealObserver.observe(root);
    }
  }
  root.dataset.accordionReady='true';
  return () => {clearTimeout(revealTimer);revealObserver?.disconnect();cleanups.forEach(fn=>fn());motion.removeEventListener('change',reduce);window.removeEventListener('hashchange',revealHash);delete root.dataset.accordionReady;delete root.dataset.accordionRevealState;root.classList.remove('is-visible');};
}
